import React, { ReactElement } from "react";

import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Drawer from "@mui/material/Drawer";
import { DrawerProps } from "@mui/material/Drawer";
import Grid from "@mui/material/Grid";
import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import { useSelector } from "../store";
import NamespaceRoleGuard from "./NamespaceRoleGuard";
import SaveButton from "./SaveButton";

type Props = DrawerProps & {
  name: string;
  cancelType: "Discard" | "Back";
  allowCancel: boolean;
  allowSave: boolean;
  onCancel?: () => void;
  onSave: () => void;
};

const DrawerHeightDiv = styled("div")({
  height: "70px",
});

const StickyEditBar = ({
  name,
  allowCancel,
  allowSave,
  onCancel,
  cancelType,
  onSave,
}: Props): ReactElement => {
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const { clusterId } = useSelector((state) => state.current);
  return (
    <>
      <Drawer
        anchor="bottom"
        open
        variant="persistent"
        PaperProps={{
          sx: isLarge
            ? {
                left:
                  (document.getElementById("sideNavBar")?.clientWidth || 0) +
                  "px",
              }
            : {},
        }}
      >
        <Container
          maxWidth={false}
          sx={{
            padding: 2,
          }}
        >
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid />
            <Grid>
              <NamespaceRoleGuard
                role={"manager"}
                namespaceId={clusterId}
                warn={false}
              >
                <Button
                  variant="contained"
                  disabled={!allowCancel}
                  onClick={(): void => onCancel?.()}
                  sx={{
                    marginRight: 2,
                  }}
                >
                  {cancelType}
                </Button>
                <SaveButton
                  variant="contained"
                  color="primary"
                  type="button"
                  disabled={!allowSave}
                  onClick={(): void => onSave?.()}
                >
                  Save {name}
                </SaveButton>
              </NamespaceRoleGuard>
            </Grid>
          </Grid>
        </Container>
      </Drawer>
      <DrawerHeightDiv />
    </>
  );
};
export default StickyEditBar;
